<template>
  <div class="home">
    <span style="background: #fff; display: block;padding: 10px;">
      <span style="margin-bottom:10px;display: block;">
        机组： <el-select v-model="selectType" clearable placeholder="请选择" @change="select_fn">
          <el-option v-for="item in options" :key="item.deviceNo" :label="item.deviceName" :value="item.deviceNo">
          </el-option>
        </el-select>
        <span style="margin-left:20px">
          日期:
          <el-date-picker v-model="openTime" type="datetimerange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" @change="openTime_fn" :picker-options="pickerOptions">
          </el-date-picker>
        </span>
        <!-- <span>
          关机时间:
          <el-date-picker v-model="conditions.clearTime" :picker-options="pickerOptions" value-format='yyyy-MM-dd'
            format='yyyy-MM-dd' type="date" placeholder="选择日期" clearable>
          </el-date-picker>
        </span> -->

        <el-button icon="el-icon-search" size="mini" style="margin-left:15px;" @click="findReportList_fn"
          type="primary">搜索
        </el-button>

        <el-button type="primary" style="margin-left:15px;" size="mini" @click="exportList"
          :disabled="!tableHeaderFlag">导出excel<i class="el-icon-download"></i></el-button>

        <!-- <el-button type="primary" style="margin-left:15px;" size="mini" @click="exportList2" :disabled="!tableHeaderFlag">导出excel<i
            class="el-icon-download"></i></el-button> -->
      </span>
      <div class="sele-list" style="width:75%" v-show="!tableHeaderFlag">
        <el-table :data="actionList" border height="5.1rem">
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="deviceName" label="名称" width="200">
            <template #default="{ row, column, $index}">
              <span>{{row.deviceName}} - {{ $index + 1 }}#</span>
              <span v-show="false">{{column}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="startStatus" label="开机状态" width="100"> </el-table-column>
          <el-table-column prop="stopStatus" label="启动状态" width="100"> </el-table-column>
          <el-table-column prop="startTime" label="开机时间" width="300">
            <template #default="{row}">
              <span>{{row.startTime | date_format}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stopTime" label="关机时间" width="300">
            <template #default="{row}">
              <span>{{row.stopTime | date_format}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="220">
            <template #default="{row}">
              <span class="buttoned_box">
                <el-button type="text" @click="edit_ed(row)"
                  style="color:#409eff;font-weight: bold;font-size:16px">查看</el-button>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="memo1" label=""> </el-table-column>
        </el-table>
      </div>

      <div class="tableHeader" v-show="tableHeaderFlag">
        <div class="n">开机机组</div>
        <div class="n" style="width: 239px;">
          {{optionsName.deviceName}}
        </div>
        <div class="n" style=" width: 159px; ">开机时间</div>
        <div class="n" style="width: 239px;">
          {{optionsName.startTime | date_format }}
        </div>
        <div class="n" style="width: 159px;">关机时间</div>
        <div class="n" style="width: 239px;">
          {{optionsName.stopTime | date_format}}
        </div>
      </div>
      <el-table v-show="tableHeaderFlag" style="borderColor: #000;width: 100% " :header-cell-style="header_nf"
        :maxHeight="770" stripe :data="tableData" border :cell-style="{borderColor:'#000'}" id="tabled" class="table">
        <template slot="empty">
          <span class="noData">
            <img src="../../assets/noData.png" alt="暂无数据">
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column label="序号" type="index" align="center" width="90" fixed="left" />
        <el-table-column label="时间" align="center" width="180" fixed="left">
          <template #default="{row}">
            <span>{{row.createTime | date_format}}</span>
          </template>
        </el-table-column>
        <el-table-column label="运行电流(A)" align="center">
          <el-table-column label="A" align="center" width="80">
            <template #default="{row}">
              <span>{{row.electricityA}}</span>
            </template>
          </el-table-column>
          <el-table-column label="B" align="center" width="80">
            <template #default="{row}">
              <span>{{row.electricityB }}</span>
            </template>
          </el-table-column>
          <el-table-column label="C" align="center" width="80">
            <template #default="{row}">
              <span>{{row.electricityC}}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="运行电压(kV)" align="center" width="100">
          <el-table-column label="AB" align="center" width="80">
            <template #default="{row}">
              <span>{{row.voltageAb }}</span>
            </template>
          </el-table-column>
          <el-table-column label="BC" align="center" width="80">
            <template #default="{row}">
              <span>{{row.voltageBc }}</span>
            </template>
          </el-table-column>
          <el-table-column label="AC" align="center" width="80">
            <template #default="{row}">
              <span>{{row.voltageAc }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="有功功率(kW)" align="center" width="80">
          <template #default="{row}">
            <span>{{row.activePower }}</span>
          </template>
        </el-table-column>
        <el-table-column label="无功功率(kvar)" align="center" width="80">
          <template #default="{row}">
            <span>{{row.reactivePower }}</span>
          </template>
        </el-table-column>
        <el-table-column label="定子温度(℃)" align="center">
          <el-table-column label="U" align="center" width="80">
            <template #default="{row}">
              <span>{{row.statorU }}</span>
            </template>
          </el-table-column>
          <el-table-column label="V" align="center" width="80">
            <template #default="{row}">
              <span>{{row.statorV }}</span>
            </template>
          </el-table-column>
          <el-table-column label="W" align="center" width="80">
            <template #default="{row}">
              <span>{{row.statorW }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="电机轴承温度(℃)" align="center">
          <el-table-column label="上轴承" align="center" width="80">
            <template #default="{row}">
              <span>{{row.bearingsTUp }}</span>
            </template>
          </el-table-column>
          <el-table-column label="下轴承" align="center" width="80">
            <template #default="{row}">
              <span>{{row.bearingsTBelow }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="绕组温度(℃)" align="center">
          <el-table-column label="U" align="center" width="80">
            <template #default="{row}">
              <span>{{row.windingU }}</span>
            </template>
          </el-table-column>
          <el-table-column label="V" align="center" width="80">
            <template #default="{row}">
              <span>{{row.windingV }}</span>
            </template>
          </el-table-column>
          <el-table-column label="W" align="center" width="80">
            <template #default="{row}">
              <span>{{row.windingW }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="电机轴承振动(mm/s)" align="center">
          <el-table-column label="上轴承X" align="center" width="80">
            <template #default="{row}">
              <span>{{row.bearingsVibUpX }}</span>
            </template>
          </el-table-column>
          <el-table-column label="上轴承Y" align="center" width="80">
            <template #default="{row}">
              <span>{{row.bearingsVibUpY }}</span>
            </template>
          </el-table-column>
          <el-table-column label="下轴承X" align="center" width="80">
            <template #default="{row}">
              <span>{{row.bearingsVibBelowX }}</span>
            </template>
          </el-table-column>
          <el-table-column label="下轴承Y" align="center" width="80">
            <template #default="{row}">
              <span>{{row.bearingsVibBelowY }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="泵轴振动(μm)" align="center">
          <el-table-column label="泵轴振动X" align="center" width="80">
            <template #default="{row}">
              <span>{{row.pumpVibX }}</span>
            </template>
          </el-table-column>
          <el-table-column label="泵轴振动Y" align="center" width="80">
            <template #default="{row}">
              <span>{{row.pumpVibY}}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="泵轴摆度(μm)" align="center">
          <el-table-column label="泵轴摆度X" align="center" width="80">
            <template #default="{row}">
              <span>{{row.pumpSwingX }}</span>
            </template>
          </el-table-column>
          <el-table-column label="泵轴摆度Y" align="center" width="80">
            <template #default="{row}">
              <span>{{row.pumpSwingY }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="水位监测(m)" align="center">
          <el-table-column label="内河" align="center" width="80">
            <template #default="{row}">
              <span>{{row.waterLevelInner }}</span>
            </template>
          </el-table-column>
          <el-table-column label="外江" align="center" width="80">
            <template #default="{row}">
              <span>{{row.waterLevelExternal }}</span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>


      <!-- 分页 -->
      <!-- <div class="fenye">
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :total="total">
        </el-pagination>
      </div> -->

    </span>
  </div>
</template>
<script>
  import FileSaver from "file-saver";
  import XLSX from "xlsx";
  import {findDeviceList,findReportList,findReportDetails} from "../../api/monitoring.js"
  /* eslint-disable */
  let idTmr;
  const getExplorer=() => {
    let explorer=window.navigator.userAgent;
    //ie
    if(explorer.indexOf("MSIE")>=0) {
      return 'ie';
    }
    //firefox

    else if(explorer.indexOf("Firefox")>=0) {
      return 'Firefox';
    }
    //Chrome
    else if(explorer.indexOf("Chrome")>=0) {
      return 'Chrome';
    }
    //Opera
    else if(explorer.indexOf("Opera")>=0) {
      return 'Opera';
    }
    //Safari
    else if(explorer.indexOf("Safari")>=0) {
      return 'Safari';
    }
  }
  // 判断浏览器是否为IE
  const exportToExcel=(data,name) => {

    // 判断是否为IE
    if(getExplorer()=='ie') {
      tableToIE(data,name)
    } else {
      tableToNotIE(data,name)
    }
  }

  const Cleanup=() => {
    window.clearInterval(idTmr);
  }

  // ie浏览器下执行
  const tableToIE=(data,name) => {
    let curTbl=data;
    let oXL=new ActiveXObject("Excel.Application");

    //创建AX对象excel
    let oWB=oXL.Workbooks.Add();
    //获取workbook对象
    let xlsheet=oWB.Worksheets(1);
    //激活当前sheet
    let sel=document.body.createTextRange();
    sel.moveToElementText(curTbl);
    //把表格中的内容移到TextRange中
    sel.select;
    //全选TextRange中内容
    sel.execCommand("Copy");
    //复制TextRange中内容
    xlsheet.Paste();
    //粘贴到活动的EXCEL中

    oXL.Visible=true;
    //设置excel可见属性

    try {
      let fname=oXL.Application.GetSaveAsFilename("Excel.xls","Excel Spreadsheets (*.xls), *.xls");
    } catch(e) {
      print("Nested catch caught "+e);
    } finally {
      oWB.SaveAs(fname);

      oWB.Close(savechanges=false);
      //xls.visible = false;
      oXL.Quit();
      oXL=null;
      // 结束excel进程，退出完成
      window.setInterval("Cleanup();",1);
      idTmr=window.setInterval("Cleanup();",1);
    }
  }

  // 非ie浏览器下执行
  const tableToNotIE=(function() {
    // 编码要用utf-8不然默认gbk会出现中文乱码
    let uri='data:application/vnd.ms-excel;base64,',
      template='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table border="1">{table}</table></body></html>',
      base64=function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },

      format=(s,c) => {
        return s.replace(/{(\w+)}/g,
          (m,p) => {
            return c[p];
          })
      }
    return (table,name) => {
      let ctx={
        worksheet: name,
        table
      }

      //创建下载
      let link=document.createElement('a');
      console.log(name,'nnnnnnnn');
      link.setAttribute('href',uri+base64(format(template,ctx)));
      link.setAttribute('download',name);
      link.click();
    }
  })()

  // 导出函数
  const export2Excel=(theadData,tbodyData,dataname) => {

    let re=/http/ // 字符串中包含http,则默认为图片地址
    let th_len=theadData.length // 表头的长度
    let tb_len=tbodyData.length // 记录条数
    let width=70 // 设置图片大小
    let height=70

    // 添加表头信息
    let thead='<thead><tr>'
    for(let i=0;i<th_len;i++) {
      if(i%2==0) {
        thead+='<th colspan=2>'+theadData[i]+'</th>'
      } else {
        thead+='<th colspan=4>'+theadData[i]+'</th>'
      }

    }
    thead+='</tr></thead>'

    // 添加每一行数据
    let tbody='<tbody>'
    for(let i=0;i<tb_len;i++) {
      tbody+='<tr>'
      let row=tbodyData[i] // 获取每一行数据

      for(let key in row) {
        if(re.test(row[key])) { // 如果为图片，则需要加div包住图片
          // 
          tbody+='<td style="width:'+width+'px; height:'+height+'px; text-align: center; vertical-align: middle"><div style="display:inline"><img src=\''+row[key]+'\' '+' '+'width='+'\"'+width+'\"'+' '+'height='+'\"'+height+'\"'+'></div></td>'
        } else {
          tbody+='<td style="text-align:center">'+row[key]+'</td>'
        }
      }
      tbody+='</tr>'
    }
    tbody+='</tbody>'


    // 添加尾巴信息
    let foote='<thead><tr>'
    foote+='<th style="text-align:left" colspan=5>'+'运行情况：'+'</th>'
    foote+='<th style="text-align:left" colspan=15>'+''+'</th>'
    foote+='<th style="text-align:left" colspan=5>'+'操作者签名：'+'</th>'
    foote+='<th colspan=3>'+'  年   月   日'+'</th>'
    foote+='</tr></thead>'
    var aa=document.getElementsByTagName('thead')[0]; //头部表头
    var bb=document.getElementsByTagName('tbody')[0]; //列表内容
    let table=thead+aa.innerHTML+bb.innerHTML+foote;
    // 导出表格
    console.log("表格",this.conditions);

    return
    exportToExcel(table,dataname)
  };

  var axios=require('axios')
  export default {
    data () {
      return {
        total: 0,
        selectType: "",
        oneData: [],//根据第一条数据获取时间
        // openTime: [1658839022000,1659271022000],//日期
        openTime: [new Date(),new Date()],//日期
        columnLabel: [],//头部表头
        optionsName: {
          name: '',
          endTime: '',
          startTime: ''
        },//机组名称
        options: [],//下拉框列表数据
        pickerOptions: {//限制时间选择
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
        },
        conditions: {//传参
          deviceNo: '-111',
          startTime: 1658839022000,
          endTime: 1659271022000,
        },//搜索条件
        tableData: [],
        all_data: [],//总数据
        actionList: [],
        tableHeaderFlag: false,
        decIndex: 10,
      };
    },

    filters: {
      // 过滤数据
      data_fn (data,a,b) {
        if(data) {
          for(let e=0;e<data.length;e++) {
            const row=data[e];
            if(row.variablename.indexOf(b)!=-1) {
              var key=Object.keys(row)//获取所有key 
              for(let i=1;i<key.length;i++) {
                if(key[i].indexOf(a)!=-1) {//判断时间在value第5的开始位置  
                  return row[key[i]]
                  break
                }
              }
            }
          }
        }

        return '-'
      },
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return `'${strDate}'`
      },

    },
    mounted () {
      //  this.newGetList() //测试数据
      // this.getList();//获取列表数据 
      this.getSelectionList_fn()//下拉框数据/

    },
    methods: {
      //获取下拉框列表数据
      getSelectionList_fn () {
        findDeviceList().then(res => {
          this.options=res.data
          this.selectType=res.data[0].deviceNo
          this.findReportList_fn()
        })
      },
      //下拉框改变
      select_fn (val) {
        this.tableHeaderFlag=false
        this.selectType=val
        this.findReportList_fn()
      },
      //列表数据
      findReportList_fn () {
        var d={
          'deviceNo': this.selectType,
          "startTime": this.openTime[0].getTime(),
          "endTime": this.openTime[1].getTime(),
        }
        findReportList(d).then(res => {
          this.actionList=res.data
        })
      },
      //点击查看可查看详情
      edit_ed (row) {

        this.optionsName=row
        this.decIndex=this.actionList.findIndex(item => item.id==row.id)
        var d={
          'deviceNo': row.deviceNo,
          'reportId': row.id,
          'startTime': row.startTime,
          'stopTime': row.stopTime,
          'stopStatus': row.stopStatus=='Y'? 1:0,
        }
        this.tableHeaderFlag=true
        findReportDetails(d).then(res => {
          if(res.code==200) {
            this.tableData=res.data
          } else {
            this.$message({message: '获取失败',type: 'warning'});
          }
        })
      },
      openTime_fn (v) {
        if(v) {
          this.conditions.startTime=v[0].getTime();
          this.conditions.endTime=v[1].getTime();
        } else {
          delete this.conditions.startTime;
          delete this.conditions.endTime;
        }

      },

      handleCurrentChange (val) {


        this.tableData=this.all_data[val-1].data;
        this.optionsName.endTime=this.all_data[val-1].endTime? this.parseTime(this.all_data[val-1].endTime):'';
        this.optionsName.startTime=this.all_data[val-1].startTime? this.parseTime(this.all_data[val-1].startTime):'';
        console.log(`当前页: ${val}`);
      },
      //头部样式
      header_nf (v) {
        return {color: '#000',fontFamily: 'MicrosoftYaHeiUI',fontSize: '14px',fontWeight: 900,backgroundColor: '#FFF',borderColor: ' #000'}
      },
      //获取列表数据
      getList () {

        axios.defaults.timeout=5000;//设置超时时间，单位毫秒
        axios({
          url: 'http://10.50.52.108:19000/history/getPumpRunInfo.do',
          method: 'POST',
          params: this.conditions,
          withCredentials: false, //表示跨域请求时是否需要使用凭证 
        })
          .then(res => {
            this.options.map(v => { //赋值机组名称
              if(v.value==this.conditions.deviceNo) {
                this.optionsName.name=v.label;
              }
            })
            if(res.data.success) {
              this.all_data=res.data.data;
              this.total=this.all_data.length*10;
              if(this.total) {
                this.tableData=this.all_data[0].data||[]; //第一页数据
                this.oneData=[];//第一条时间
                var index=this.tableData.length/27; //总数除27得到天数
                for(let e=0;e<index;e++) {
                  var d=Object.keys(this.tableData[e*27]);
                  for(let i=0;i<d.length;i++) {
                    if(d[i].indexOf("value")!=-1) {
                      var a=d[i].split("value")
                      this.oneData.push(a[1])
                    }
                  }
                }

                this.optionsName.endTime=this.all_data[0].endTime? this.parseTime(this.all_data[0].endTime):'';
                this.optionsName.startTime=this.all_data[0].startTime? this.parseTime(this.all_data[0].startTime):'';

              }
            }
          })
          .catch(err => {

            var res=this.tableData_fn();

            this.options.map(v => { //赋值机组名称
              if(v.value==this.conditions.deviceNo) {
                this.optionsName.name=v.label;
              }
            })
            if(res.success) {
              this.all_data=res.data;
              this.total=this.all_data.length*10;
              if(this.total) {
                this.tableData=this.all_data[0].data||[]; //第一页数据
                this.oneData=[];//第一条时间
                var index=this.tableData.length/27; //总数除27得到天数
                for(let e=0;e<index;e++) {
                  var d=Object.keys(this.tableData[e*27]);
                  for(let i=0;i<d.length;i++) {
                    if(d[i].indexOf("value")!=-1) {
                      var a=d[i].split("value")
                      this.oneData.push(a[1])
                    }
                  }
                }

                this.optionsName.endTime=this.all_data[0].endTime? this.parseTime(this.all_data[0].endTime):'';
                this.optionsName.startTime=this.all_data[0].startTime? this.parseTime(this.all_data[0].startTime):'';

              }
            }

          })
      },

      //获取详情数据
      newGetList () {
        var res={
          "code": 200,
          "message": "操作成功",
          "data": [{
            "id": 253223494400001,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462160000,
            "electricityA": "A相电流",
            "electricityB": "B相电流",
            "electricityC": "C相电流",
            "voltageAb": "AB线电压",
            "voltageBc": "BC线电压",
            "voltageAc": "AC线电压",
            "activePower": "有功功率",
            "reactivePower": "无功功率",
            "statorU": "定子温度U",
            "statorV": "定子温度V",
            "statorW": "定子温度W",
            "bearingsTUp": "上轴承温度",
            "bearingsTBelow": "下轴承温度",
            "windingU": "绕组温度U",
            "windingV": "绕组温度V",
            "windingW": "绕组温度W",
            "bearingsVibUpX": "电机轴承震动-上轴承X",
            "bearingsVibUpY": "电机轴承震动-上轴承Y",
            "bearingsVibBelowX": "电机轴承震动-下轴承X",
            "bearingsVibBelowY": "	电机轴承震动-下轴承Y",
            "pumpVibX": "泵轴承震动-X",
            "pumpVibY": "泵轴承震动-Y",
            "pumpSwingX": "	泵轴承摇度-X",
            "pumpSwingY": "	泵轴承摇度-Y",
            "waterLevelInner": "水位检测-内河",
            "waterLevelExternal": "水位检测-外江"
          },{
            "id": 253223498358785,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          },{
            "id": 253223498358787,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          },{
            "id": 253223498358789,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          },{
            "id": 253223498318785,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          },{
            "id": 253233498358785,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          },{
            "id": 2532234983587810,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          },{
            "id": 2532234983587425,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          },{
            "id": 2532234983587465,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          },{
            "id": 2532234298358785,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          },{
            "id": 2532234983458785,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          },{
            "id": 2532234983587855446,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          },{
            "id": 25322349821358785,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          },{
            "id": 25322349321658358785,
            "reportId": 253223493470209,
            "switchType": "Y",
            "createTime": 1676462162000,
            "electricityA": 0.29,
            "electricityB": 0.0,
            "electricityC": 0.19,
            "voltageAb": null,
            "voltageBc": null,
            "voltageAc": null,
            "activePower": 1.8,
            "reactivePower": 1.84,
            "statorU": null,
            "statorV": null,
            "statorW": null,
            "bearingsTUp": null,
            "bearingsTBelow": null,
            "windingU": null,
            "windingV": null,
            "windingW": null,
            "bearingsVibUpX": null,
            "bearingsVibUpY": null,
            "bearingsVibBelowX": null,
            "bearingsVibBelowY": null,
            "pumpVibX": null,
            "pumpVibY": null,
            "pumpSwingX": null,
            "pumpSwingY": null,
            "waterLevelInner": null,
            "waterLevelExternal": null
          }]
        }
        // var res=this.tableData_fn();

        // console.log(res.data[0].data);

        this.tableData=res.data
        console.log(this.tableData);


      },



      // 时间格式化
      parseTime (time,cFormat) {
        if(arguments.length===0) {
          return null
        }
        const format=cFormat||'{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if(typeof time==='object') {
          date=time
        } else {
          if((typeof time==='string')&&(/^[0-9]+$/.test(time))) {
            time=parseInt(time)
          }
          if((typeof time==='number')&&(time.toString().length===10)) {
            time=time*1000
          }
          date=new Date(time)
        }
        const formatObj={
          y: date.getFullYear(),
          m: date.getMonth()+1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str=format.replace(/{([ymdhisa])+}/g,(result,key) => {
          const value=formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if(key==='a') {return ['日','一','二','三','四','五','六'][value]}
          return value.toString().padStart(2,'0')
        })
        return time_str
      },
      // 时间戳转换
      // 转换时间戳
      date_format_fn (value) {
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return `'${strDate}'`
      },

      // 下载excel
      exportList () {
        const tHeader=['开机机组',this.optionsName.deviceName+'-'+(this.decIndex+1)+'# ','开机时间',this.date_format_fn(this.optionsName.startTime),
          '关机时间',this.date_format_fn(this.optionsName.stopTime)];

        this.export2Excel(tHeader,this.tableData,this.optionsName.deviceName+'-'+(this.decIndex+1)+'# 泵站运行报告');
        //  const tHeader = ["序号", "时间", "A", "B", "C", "AB", "BC", "AC", "有功功率(kW)", "无功功率(kvar)", "U", "V", "W", "上轴承", "下轴承", "U", "V", "W", "上轴承X", "下轴承Y", "上轴承X", "下轴承Y", "泵轴振动X", "泵轴振动Y", "泵轴摆度X", "泵轴摆度Y", "内河", "外江"]

      },
      exportList2 () {
        // 设置当前日期
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        let name=this.optionsName.deviceName+'-'+(this.decIndex+1)+'# '+" "+year+"-"+month+"-"+day;
        // console.log(name)
        /* generate workbook object from table */
        //  .table要导出的是哪一个表格

        var wb=XLSX.utils.table_to_book(document.querySelector(".table"));
        /* get binary string as output */
        var wbout=XLSX.write(wb,{
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          //  name+'.xlsx'表示导出的excel表格名字
          FileSaver.saveAs(
            new Blob([wbout],{type: "application/octet-stream"}),
            name+".xlsx"
          );
        } catch(e) {
          if(typeof console!=="undefined") console.log(e,wbout);
        }
        return wbout;
      },



      export2Excel (theadData,tbodyData,dataname) {
        let re=/http/ // 字符串中包含http,则默认为图片地址
        let th_len=theadData.length // 表头的长度
        let tb_len=tbodyData.length // 记录条数
        let width=70 // 设置图片大小
        let height=70

        // 添加表头信息
        let thead='<thead><tr>'
        for(let i=0;i<th_len;i++) {
          console.log(theadData);
          if(i%2==0) {
            thead+='<th colspan=2>'+theadData[i]+'</th>'
          } else {
            thead+='<th colspan=4>'+theadData[i]+'</th>'
          }


        }
        thead+='</tr></thead>'


        // 添加每一行数据
        let tbody='<tbody>'
        for(let i=0;i<tb_len;i++) {
          tbody+='<tr>'
          let row=tbodyData[i] // 获取每一行数据

          for(let key in row) {
            if(re.test(row[key])) { // 如果为图片，则需要加div包住图片
              // 
              tbody+='<td style="width:'+width+'px; height:'+height+'px; text-align: center; vertical-align: middle"><div style="display:inline"><img src=\''+row[key]+'\' '+' '+'width='+'\"'+width+'\"'+' '+'height='+'\"'+height+'\"'+'></div></td>'
            } else {
              tbody+='<td style="text-align:center">'+row[key]+'</td>'
            }
          }
          tbody+='</tr>'
        }
        tbody+='</tbody>'
        // 添加尾巴信息
        let foote='<thead><tr>'
        foote+='<th style="text-align:left" colspan=5>'+'运行情况：'+'</th>'
        foote+='<th style="text-align:left" colspan=15>'+''+'</th>'
        foote+='<th style="text-align:left" colspan=5>'+'操作者签名：'+'</th>'
        foote+='<th colspan=3>'+'  年   月   日'+'</th>'
        foote+='</tr></thead>'
        var aa=document.getElementsByTagName('thead')[1]; //头部表头
        var bb=document.getElementsByTagName('tbody')[1];
        //列表内容
        let table=thead+aa.innerHTML+bb.innerHTML+foote;
        // 导出表格
        exportToExcel(table,dataname)
      },



      //测试数据
      tableData_fn () {}

    }
  };
</script>
<style>
  .pickerTime input {
    border: none;
  }

  input::-webkit-input-placeholder {

    color: #000 !important;

    font-size: 14px;

  }
</style>
<style lang="scss" scoped>
  .tableHeader {
    display: flex;
    border: 1px solid;
    border-bottom: none;
    height: 48px;
    align-items: center;
  }

  .sele-list {
    /deep/th {
      background-color: #f1f8ff !important;
    }
  }

  .tableHeader div {
    font-size: 16px;
  }

  .tableHeader .n {
    height: 48px;
    line-height: 48px;
    border-right: 1px solid;
    width: 129px;
    text-align: center;
  }

  .home {
    box-sizing: border-box;
    background-color: #e9ebef;
    padding: 10px;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .fenye {
    display: flex;
    justify-content: flex-end;
  }
</style>